<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#imports'
import { inputVariants, type InputVariants } from '.'

const props = defineProps<{
  class?: HTMLAttributes['class']
  variant?: InputVariants['variant']
}>()

const modelValue = defineModel<string | number>()
</script>

<template>
  <input
    v-model="modelValue"
    :class="cn(inputVariants({ variant }), props.class)"
  />
</template>
